<template>
  <mymodal ref="theModal" :need-header="true" :need-footer="false" :size="'medium'">
    <div slot="title">{{getTitleText}}</div>
    <div slot="body">
      <form v-on:submit.prevent="submitForm">
        <div class="row">
          <div class="col-md-6 mt20">
            <label>
              {{'Name'|translate}}
              <span class="required">(*)</span>
            </label>
            <input
              v-model="item.name"
              required
              ref="name"
              :placeholder="'Name'|translate"
              class="form-control"
            />
          </div>
          <div class="col-md-6 mt20">
            <label>
              {{'Start year'|translate}}
              <span class="required">(*)</span>
            </label>
            <input
              v-model="item.start_year"
              type="number"
              required
              ref="start_year"
              :placeholder="'Start year'|translate"
              class="form-control"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt20">
            <label>
              {{'Area'|translate}}
              <span class="required">(*)</span>
            </label>
            <input
              v-model="item.area"
              type="number"
              required
              ref="area"
              :placeholder="'Area'|translate"
              class="form-control"
            />
          </div>
          <div class="col-md-6 mt20">
            <label>
              {{'Garden'|translate}}
              <span class="required">(*)</span>
            </label>
            <select class="form-control" v-model="item.garden_id" required>
              <option disabled value>{{'Please select one'|translate}}</option>
              <option
                v-for="(garden) in gardens"
                :key="garden.id"
                v-bind:value="garden.id"
              >{{ garden.name }}</option>
            </select>
          </div>
        </div>
        <label class="mt20">{{'Note'|translate}}</label>
        <input v-model="item.note" ref="note" :placeholder="'Note'|translate" class="form-control" />
        <button class="btn btn-info mt20" type="submit" :disabled="working">
          <i v-if="working" class="fas fa-spinner fa-spin"></i>
          {{getOKText}}
        </button>
      </form>
    </div>
  </mymodal>
</template>
<script>
import mymodal from "@/components/elements/Modal";
import Utils from "@/helpers/utils";

//import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: "FormBlock",
  components: {
    mymodal
  },
  props: ["pass_data", "gardens"],
  computed: {
    getTitleText() {
      return "abc";
      // if (this.item.id) {
      //   return this.$t("Update block");
      // } else {
      //   return this.$t("Add block");
      // }
    },
    getOKText() {
      if (this.item.id) {
        return this.$t("Update");
      } else {
        return this.$t("Add");
      }
    }
  },
  data() {
    return {
      working: false,
      item: {}
    };
  },
  created() {
    // clone from original params
  },
  methods: {
    defaultValue() {
      return {
        name: "",
        garden_id: ""
      };
    },
    open() {
      this.$refs.theModal.open();
      if (this.pass_data) {
        this.item = this.pass_data;
      } else {
        this.item = this.defaultValue();
      }

      //   for (let key in this.searchparams) {
      //     this.search_params[key] = this.searchparams[key]
      //   }
    },
    ok() {},
    submitForm() {
      let data = this.item;
      let request;
      if (this.item.id) {
        request = Utils.request(this, true, "land").put(`/manageBlock/`, data);
      } else {
        request = Utils.request(this, true, "land").post(`/manageBlock/`, data);
      }

      request
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            this.$refs.theModal.close();
            this.$emit("modalData", {});
          } else {
            Utils.showError(this, this.$t(data.data));
          }
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Cultivation/FormBlock.vue